import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.svg";

export default function Header() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSticky, setIsSticky] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  // Закрытие меню при клике вне области
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMobileMenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        closeMobileMenu();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobileMenuOpen]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);

      // Закрываем меню при переходе на десктоп
      if (!mobile) {
        closeMobileMenu();
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <header>
      <div className="container">
        <nav className={`navbar ${isMobile ? "nav-mobile" : "nav-desktop"}`}>
          <div className="container-fluid">
            <Link to="/" onClick={closeMobileMenu}>
              <img src={logo} alt="logo" />
            </Link>

            {isMobile && (
              <button
                ref={buttonRef}
                className={`navbar-toggler ${isMobileMenuOpen ? "active" : ""}`}
                type="button"
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
            )}

            <div
              ref={menuRef}
              className={`collapse navbar-collapse ${isMobileMenuOpen ? "show" : ""}`}
            >
              <ul className="navbar-nav">
                <li className="nav-item">
                  <Link
                    to="/"
                    className="nav-link active"
                    onClick={closeMobileMenu}
                  >
                    Главная
                  </Link>
                </li>

                <li
                  className="nav-item dropdown"
                  onMouseEnter={() => !isMobile && setIsDropdownOpen(true)}
                  onMouseLeave={() => !isMobile && setIsDropdownOpen(false)}
                >
                  <Link
                    to="#"
                    className="nav-link"
                    onClick={(e) => {
                      if (isMobile) {
                        e.preventDefault();
                        toggleDropdown();
                      }
                    }}
                  >
                    Услуги
                  </Link>

                  <ul
                    className={`dropdown-menu ${isDropdownOpen ? "show" : ""}`}
                  >
                    <li>
                      <Link
                        to="/web-development"
                        className="dropdown-item"
                        onClick={closeMobileMenu}
                      >
                        Веб-разработка
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/mobile"
                        className="dropdown-item"
                        onClick={closeMobileMenu}
                      >
                        Мобильная разработка
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/logistic"
                        className="dropdown-item"
                        onClick={closeMobileMenu}
                      >
                        Автоматизация логистики
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/sklad"
                        className="dropdown-item"
                        onClick={closeMobileMenu}
                      >
                        Автоматизация склада
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/proggram"
                        className="dropdown-item"
                        onClick={closeMobileMenu}
                      >
                        Разработка программного обеспечения
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="nav-item">
                  <Link to="/cases" onClick={closeMobileMenu}>
                    Кейсы
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to="/team" onClick={closeMobileMenu}>
                    Наша команда
                  </Link>
                </li>

                <div className="navbtnBlock">
                  <Link
                    to="/contacts"
                    className="btn btnCallBack"
                    onClick={closeMobileMenu}
                  >
                    Контакты
                  </Link>
                  <Link
                    to="#"
                    className="btnTg"
                    target="_blank"
                    onClick={closeMobileMenu}
                  ></Link>
                </div>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
}
